import { render, staticRenderFns } from "./VehicleRecursionTree2.vue?vue&type=template&id=ed2f6c10&scoped=true"
import script from "./VehicleRecursionTree2.vue?vue&type=script&lang=js"
export * from "./VehicleRecursionTree2.vue?vue&type=script&lang=js"
import style0 from "./VehicleRecursionTree2.vue?vue&type=style&index=0&id=ed2f6c10&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2f6c10",
  null
  
)

export default component.exports